import {
  WORK_ORDERS_DETAILS_BUDGET_BACK,
  WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET,
  WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD,
  WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR,
  WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET,
  WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE,
  WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET,
  WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET,
  WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET,
  WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET,
  WORK_ORDERS_DETAILS_BUDGET_NEXT,
  WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE,
  WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS,
  WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET,
  WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK,
  WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS,
  WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE,
  WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT,
} from 'actions/admin/work-orders/action-types';
import {
  addQualificationSuccess,
  clearQualificationsSelected,
  loadDefaultQualificationsRequest,
  loadQualificationsSuccess,
  setSelectedQualificationsById,
} from 'actions/admin/work-orders/details/qualifications';
import { getTasks } from 'selectors/admin/work-orders/work-orders';
import {
  calculateFee,
  calculateInsurace,
  calculateMarkup,
} from 'services/utils/proposal-util';
import { showErrorMessage } from 'actions/messages';
import { workOrdersApi } from 'services/api/work-orders-api';
import { setBudget } from 'actions/admin/work-orders/details/details';
import numeral from 'numeral';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import { clientsApi } from 'services/api/clients-api';

export function addEmail(email) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_EMAIL_ADD,
    payload: email,
  };
}

export function approveBudget(workOrderId, tasksId) {
  return (dispatch) => {
    return workOrdersApi
      .approveBudget(workOrderId, tasksId)
      .then((response) => {
        if (response.ok) {
          dispatch(setBudget(response.budget));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function back(view) {
  const previousActions = {
    review: 'form',
  };
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_BACK,
    payload: previousActions[view],
  };
}

export function checkTask(id, value) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_TASK_CHECK,
    payload: { id, value },
  };
}

export function clearEmails() {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_EMAIL_CLEAR,
  };
}

export function closePdfViewer() {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_PDF_VIEWER_CLOSE,
  };
}

export function createBudgetRequest(
  workOrderId,
  valuesByTaskId,
  qualifications,
  selectedQualificationsById
) {
  return (dispatch) => {
    return workOrdersApi
      .createBudget(
        workOrderId,
        valuesByTaskId,
        qualifications,
        selectedQualificationsById
      )
      .then((response) => {
        if (response.ok) {
          dispatch(next('review'));
          dispatch(setBudget(response.budget));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function createBudgetMessage(workOrderNumber, buildingLocation = null) {
  let location = '';
  if (buildingLocation !== null) {
    location = ` at ${buildingLocation.street_address_1}, ${buildingLocation.city} ${buildingLocation.state}`;
  }

  return `Please find the attached preliminary estimate for WO #${workOrderNumber}${location}. If you have any questions, please reach out via chat or email.

Thank you`;
}

export function createBudgetSubject(workOrderNumber, workOrderName = null) {
  const prefix = `Spackle Preliminary Estimate for WO #${workOrderNumber}`;
  if (workOrderName !== null && workOrderName !== '') {
    return `${prefix} - ${workOrderName}`;
  } else {
    return prefix;
  }
}

export function initializeEmailValues(
  workOrderNumber,
  workOrderName,
  buildingLocation,
  users
) {
  return (dispatch) => {
    // Create and dispatch generated subject and message
    dispatch(
      setBudgetSubject(createBudgetSubject(workOrderNumber, workOrderName))
    );
    dispatch(
      setBudgetMessage(createBudgetMessage(workOrderNumber, buildingLocation))
    );

    // Clear emails
    dispatch(clearEmails());
    // Add client owner by default
    const owner = users.find((user) => usersUtil.hasRole(user, ROLES.OWNER));
    if (owner !== undefined) {
      dispatch(addEmail(owner.email));
    }
  };
}

export function initializeValuesByTaskId(valuesByTaskId) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_VALUES_INIT,
    payload: valuesByTaskId,
  };
}

export function loadEmailBudgetDataRequest(
  workOrderNumber,
  workOrderName,
  buildingLocation,
  clientId
) {
  return (dispatch) => {
    return clientsApi.getUsers(clientId).then((response) => {
      if (response.ok) {
        // Process client users response
        dispatch(loadUsersSuccess(response.users));

        dispatch(
          initializeEmailValues(
            workOrderNumber,
            workOrderName,
            buildingLocation,
            response.users
          )
        );
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadUsersSuccess(users) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_USERS_LOAD_SUCCESS,
    payload: users,
  };
}

export function next(view) {
  const nextActions = {
    form: 'review',
    review: 'thank-you',
  };
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_NEXT,
    payload: nextActions[view],
  };
}

export function openApproveReviewModal(budget) {
  return (dispatch, getState) => {
    const selectedQualificationsById = budget.budget_qualifications.reduce(
      (accumulator, currentValue) => {
        accumulator[currentValue.qualification_id] = {
          id: currentValue.qualification_id,
          option:
            currentValue.option !== null
              ? { value: 0, label: currentValue.option }
              : null, // value=0 because we only need the label
        };
        return accumulator;
      },
      {}
    );
    // Load data in store to use QualificationContainer
    dispatch(setSelectedQualificationsById(selectedQualificationsById));
    dispatch(loadQualificationsSuccess(budget.qualifications));

    const currentUser = getCurrentUser(getState());
    if (usersUtil.hasType(currentUser, TYPES.CLIENT)) {
      // Check all tasks by default
      budget.budget_tasks.forEach((budgetTask) => {
        dispatch(checkTask(budgetTask.task_id, true));
      });
    }

    dispatch(setShowApproveReviewModal(true));
  };
}

export function openModal(budget = null) {
  return (dispatch, getState) => {
    // Clear qualifications data before showing the modal
    dispatch(clearQualificationsSelected());
    dispatch(loadDefaultQualificationsRequest()).then((response) => {
      if (response.ok) {
        const tasks = getTasks(getState());
        let valuesByTaskId;
        if (budget !== null) {
          // Load values for tasks
          valuesByTaskId = budget.budget_tasks.reduce(
            (accumulator, budgetTask) => {
              accumulator[budgetTask.task_id] = {
                cost: numeral(budgetTask.cost).value(),
                fee: numeral(budgetTask.fee).value(),
                markup: numeral(budgetTask.markup).value(),
                insurance: numeral(budgetTask.insurance).value(),
              };
              return accumulator;
            },
            {}
          );

          // Check if new tasks
          if (budget.budget_tasks.length !== tasks.length) {
            // New tasks, add to values
            tasks.forEach((task) => {
              if (
                budget.budget_tasks.find(
                  (budgetTask) => budgetTask.task_id === task.id
                ) === undefined
              ) {
                // New task, not part of budget tasks
                valuesByTaskId[task.id] = {
                  cost: null,
                  fee: null,
                  markup: null,
                  insurance: null,
                };
              }
            });
          }

          // Add not default qualifications that were selected when creating the budget
          budget.qualifications
            .filter((qualification) => !qualification.default)
            .forEach((qualification) =>
              dispatch(addQualificationSuccess(qualification))
            );

          // Set selected qualifications
          const selectedQualificationsById = budget.budget_qualifications.reduce(
            (accumulator, currentValue) => {
              accumulator[currentValue.qualification_id] = {
                id: currentValue.qualification_id,
                option:
                  currentValue.option !== null
                    ? { value: 0, label: currentValue.option }
                    : null, // value=0 because we only need the label
              };
              return accumulator;
            },
            {}
          );
          dispatch(setSelectedQualificationsById(selectedQualificationsById));
        } else {
          valuesByTaskId = tasks.reduce((accumulator, task) => {
            accumulator[task.id] = {
              cost: null,
              fee: null,
              markup: null,
              insurance: null,
            };
            return accumulator;
          }, {});
        }
        dispatch(initializeValuesByTaskId(valuesByTaskId));
        // If open an existing budget, open the modal in Review
        dispatch(setCurrentView(budget === null ? 'form' : 'review'));
        dispatch(setShow(true));
      }
    });
  };
}

export function printBudget(workOrderId) {
  return (dispatch) => {
    return workOrdersApi.getBudgetAsPdf(workOrderId).then((response) => {
      if (response.ok) {
        dispatch(printBudgetSuccess(response.pdf));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function printBudgetSuccess(pdf) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_PRINT_SUCCESS,
    payload: pdf,
  };
}

export function removeEmail(email) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_EMAIL_REMOVE,
    payload: email,
  };
}

export function sendEmail(workOrderId, emails, subject, message) {
  return (dispatch) => {
    return workOrdersApi
      .sendBudgetEmail(workOrderId, emails, subject, message)
      .then((response) => {
        if (!response.ok) {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setBudgetSubject(subject) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_SUBJECT_SET,
    payload: subject,
  };
}

export function setBudgetMessage(message) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_MESSAGE_SET,
    payload: message,
  };
}

export function setCurrentView(view) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_CURRENT_VIEW_SET,
    payload: view,
  };
}

export function setShow(value) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_SET,
    payload: value,
  };
}

export function setShowApprovalConfirmation(value) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVAL_CONFIRMATION_SET,
    payload: value,
  };
}

export function setShowApproveReviewModal(value) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_MODAL_SHOW_APPROVE_REVIEW_SET,
    payload: value,
  };
}

export function setShowEmailModal(value) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_EMAIL_MODAL_SHOW_SET,
    payload: value,
  };
}

export function updateBudgetValues(valuesByTaskId, budgetTasks) {
  // Take into account if new tasks were added after budget creation
  return Object.keys(valuesByTaskId).map((taskIdString) => {
    const taskId = Number.parseInt(taskIdString, 0);
    const budgetTask = budgetTasks.find(
      (budgetTask) => budgetTask.task_id === taskId
    );
    if (budgetTask !== undefined) {
      return {
        id: budgetTask.id,
        task_id: budgetTask.task_id,
        cost: valuesByTaskId[taskId].cost,
        fee: valuesByTaskId[taskId].fee,
        insurance: valuesByTaskId[taskId].insurance,
        markup: valuesByTaskId[taskId].markup,
      };
    } else {
      return {
        task_id: taskId,
        cost: valuesByTaskId[taskId].cost,
        fee: valuesByTaskId[taskId].fee,
        insurance: valuesByTaskId[taskId].insurance,
        markup: valuesByTaskId[taskId].markup,
      };
    }
  });
}

export function updateBudgetRequest(
  workOrderId,
  budget,
  valuesByTaskId,
  qualifications,
  selectedQualificationsById
) {
  return (dispatch) => {
    const budgetTasks = updateBudgetValues(valuesByTaskId, budget.budget_tasks);

    // Calculate changes in selected qualifications vs existing qualifications
    const budgetQualifications = createBudgetQualificationAttributes(
      qualifications,
      selectedQualificationsById,
      budget.budget_qualifications
    );

    return workOrdersApi
      .updateBudget(workOrderId, budgetTasks, budgetQualifications)
      .then((response) => {
        if (response.ok) {
          dispatch(setBudget(response.budget));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

/**
 * Create budget qualifications attributes based on the selected ones and existing qualifications.
 * Check if a qualification exists, changes it's value or was unselected.
 *
 * @param selectedQualificationsById
 * @param existingQualifications
 * @return {Array}
 */
export function createBudgetQualificationAttributes(
  qualifications,
  selectedQualificationsById,
  existingQualifications
) {
  const budgetQualifications = [];
  qualifications
    .filter((q) => selectedQualificationsById[q.id])
    .forEach((q) => {
      const value = selectedQualificationsById[q.id];
      const qualification = existingQualifications.find(
        (qualification) => qualification.qualification_id === value.id
      );
      if (qualification === undefined) {
        // new qualification
        budgetQualifications.push({
          qualification_id: value.id,
          option: value.option !== null ? value.option.label : null,
        });
      } else {
        // qualification exists, check if the option changed
        if (
          value.option !== null &&
          value.option.label !== qualification.option
        ) {
          budgetQualifications.push({
            id: qualification.id,
            option: value.option.label,
          });
        }
      }
    });

  // Remove existing qualifications unselected
  existingQualifications.forEach((qualification) => {
    if (
      selectedQualificationsById[qualification.qualification_id] === undefined
    ) {
      budgetQualifications.push({ id: qualification.id, _destroy: true });
    }
  });

  return budgetQualifications;
}

export function updateExtraCosts(taskId, value) {
  return (dispatch) => {
    dispatch(updateValue(taskId, 'markup', calculateMarkup(value)));
    dispatch(updateValue(taskId, 'fee', calculateFee(value)));
    dispatch(updateValue(taskId, 'insurance', calculateInsurace(value)));
  };
}

export function updateValue(taskId, valueKey, value) {
  return {
    type: WORK_ORDERS_DETAILS_BUDGET_VALUE_UPDATE,
    payload: { taskId, valueKey, value },
  };
}

export function declineBudget(workOrderId, values) {
  return (dispatch) => {
    return workOrdersApi.declineBudget(workOrderId, values).then((response) => {
      if (!response.ok) {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/budget.js